import { styled } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import { colors } from "../../utils";

export const ComparisonContainer = styled("div")(() => ({
    display: "flex",
    flex: 1,
    gap: "24px",
}));

export const SingleColumn = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
    flex: 0.2,
}));

export const FeatureContainer = styled("div")(() => ({
    display: "flex",
    height: "340px",
    alignItems: "center",
    padding: "20px 16px 20px 16px",
    borderBottom: "1px solid #EFEBF3",
    backgroundColor: "#fff"
}));

export const FeatureHeading = styled("div")({
    padding: "16px",
    borderBottom: "1px solid #EFEBF3",
    fontWeight: 700,
    fontSize: "16px",
    fontFamily: '"DM Sans", sans-serif',
    color: "#123051"
});

export const FeatureSubHeading = styled("div")(({ isActive, aligned = false }) => ({
    padding: "16px",
    height:"54px",
    borderBottom: "1px solid #EFEBF3",
    fontWeight: 500,
    fontSize: "14px",
    fontFamily: '"DM Sans", sans-serif',
    color: isActive ? "#8F38EF" : "#565556",
    ...(aligned && {
        textAlign: "center",
    }),
}))

export const SubscriptionFeatureContainer = styled("div")(
  ({ isActive, hasDiscount, isInfinity }) => ({
    display: "flex",
    flexDirection: "column",
    marginTop: "0px",
    backgroundColor: isActive
      ? "#F8F6FF"
      : isInfinity
      ? colors.yellowLight
      : "transparent",
  })
);

export const EmptyHeadingRow = styled("div")({
    padding: "16px",
    borderBottom: "1px solid #EFEBF3",
    color: "transparent",
    fontWeight: 700,
    fontSize: "16px",
    fontFamily: '"DM Sans", sans-serif',
    height:57
});

export const ModalWrapper = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
}))

export const StyledDialog = styled(Dialog)(() => ({
  "& .MuiDialog-paper": {
    borderRadius: "8px",
    padding: "20px",
    width: "450px",
    boxShadow: "0px 0px 8.9px 0px #00000040",
  },
}));

export const StyledDialogTitle = styled(DialogTitle)(() => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    ".close-icon": {
        cursor: "pointer",
    },
}))

export const IconAndTitle = styled("div")(() => ({
    display: "flex",
    alignItems: "center",
    gap: "8px",
}))

export const Title = styled("div")(() => ({
    fontWeight: 700,
    color: "#0F0F0F",
    fontSize: "20px",
    fontFamily: '"DM Sans", sans-serif',
}))

export const Separator = styled("div")(() => ({
    border: "1px solid #E1E1E1"
}))

export const Content = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
    gap: "24px",
}))

export const ContentHeading = styled("div")(() => ({
    fontWeight: 700,
    fontSize: "16px",
    color: "#565556",
    textAlign: "center",
    fontFamily: '"DM Sans", sans-serif',
}))

export const WarningTextContainer = styled("div")(() => ({
    display: "flex",
}))

export const Warning = styled("div")(({ weight }) => ({
    color: "#565556",
    fontSize: "14px",
    fontFamily: '"DM Sans", sans-serif',
    textAlign: "center",
    fontWeight: weight || 500,
}))

export const InputContainer = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
    gap: "8px",
}))

export const HelperText = styled("div")(() => ({
    color: "#565556",
    fontSize: "16px",
    fontWeight: 500,
    fontFamily: '"DM Sans", sans-serif',
}))

export const StyledDialogActions = styled(DialogActions)(() => ({
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
}))

export const CancelButton = styled("div")(() => ({
    fontSize: "16px",
    lineHeight: "20px",
    color: "#495057",
    fontFamily: '"DM Sans", sans-serif',
    cursor: "pointer",
}))

export const HideButtonContainer = styled("div")(({ isActive }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "16px",
}))